import {useEffect, useState} from "react";
import {notificationUtils} from "../utils/notificationUtils";

export const GlobalContextHooks = () => {
    const [notification, setNotification] = useState([])
    const [show, _setShow] = useState(false);

    const setShow = (value) => {
        if (!value) setNotification([])
        _setShow(value)
    }

    const pushNotification = ({ title, context, text}) => {
        _setShow(true)
        setNotification(notification.concat(notificationUtils({ title, context, text})))
    }
    return {
        notification, setNotification: pushNotification, show, setShow
    }
}